import { Coordinates } from '@bpd-library/types';
import { calculateCenter } from '@bpd-library/utilities';

import { MAP_FLY_DURATION, MAP_FLY_EASING_FUNCTION } from './constants';

const center = (map: mapboxgl.Map, coordinates: Coordinates) => {
    const center = calculateCenter(coordinates);

    map.flyTo({
        center,
        curve: 0,
        easing: MAP_FLY_EASING_FUNCTION,
        duration: MAP_FLY_DURATION,
    });
};

export default center;
